<template>
  <div class="d-contents">
    <Spinner v-if="modalLoading" class="m-auto" />
    <BaseModal
      v-else
      :title="modalTitle"
      :tabs="ADD_CONTRACTORS_MODAL_TABS"
      :current-tab-id="currentStep"
      class="contractors-modal"
      need-close-emit
      @change-tab="changeCurrentStep"
      @close="closeAddContractorModal"
    >
      <div class="d-contents">
        <ContractorsGeneralTab v-if="currentStep === CONTRACTORS_MODAL_STEPS.GENERAL" />
        <ContractorsWorksTab v-if="currentStep === CONTRACTORS_MODAL_STEPS.WORKS" />
        <ContractorsTendersTab
          v-if="currentStep === CONTRACTORS_MODAL_STEPS.TENDERS"
          :id="context.id"
        />
        <ContractorsNotesTab v-if="currentStep === CONTRACTORS_MODAL_STEPS.NOTES" />
      </div>
      <template #footer>
        <ErrorAlert v-if="errors && errors.non_field_errors" :error="errors.non_field_errors[0]" />
        <div class="spacex-12 ml-auto">
          <Button type="secondary" @click="closeAddContractorModal">
            {{ $t('Close') }}
          </Button>
          <Button v-if="!context.isEdit" @click.native="createContractorHandler">
            {{ $t('Create contractor') }}
          </Button>
          <Button v-else @click.native="saveContractorChanges">
            {{ $t('Save changes') }}
          </Button>
        </div>
      </template>
    </BaseModal>
  </div>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';
  import Button from '@/components/ui-v2/Button';
  import ContractorsGeneralTab from '@/containers/contractors/add-contractors-modal/ContractorsGeneralTab';
  import { mapActions, mapState } from 'vuex';
  import ContractorsWorksTab from '@/containers/contractors/add-contractors-modal/ContractorsWorksTab';
  import ContractorsTendersTab from '@/containers/contractors/add-contractors-modal/ContractorsTendersTab';
  import { CONTRACTORS_MODAL_STEPS } from '@/utils/constants/contractors-steps';
  import ContractorsNotesTab from '@/containers/contractors/add-contractors-modal/ContractorsNotesTab';
  import editTender from '@/utils/mixins/edit-tender';
  import ErrorAlert from '@/components/common/ErrorAlert';
  import Spinner from '@/components/ui/Spinner';

  export default {
    name: 'AddContractorsModal',
    mixins: [editTender],
    components: {
      ErrorAlert,
      ContractorsNotesTab,
      ContractorsTendersTab,
      ContractorsWorksTab,
      ContractorsGeneralTab,
      Button,
      BaseModal,
      Spinner,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          isEdit: Boolean,
          id: Number,
          step: Number,
          isTenderContractor: {
            type: Boolean,
            default: false,
          },
          addContractor: Function,
        }),
      },
    },
    data() {
      return {
        contractorName: '',
        currentStep: CONTRACTORS_MODAL_STEPS.GENERAL,
        CONTRACTORS_MODAL_STEPS,
      };
    },
    computed: {
      ...mapState('contractors', ['form', 'errors', 'modalLoading']),
      ...mapState('tenderEdit', ['tender']),
      ADD_CONTRACTORS_MODAL_TABS() {
        return this.context.isEdit
          ? [
              { id: CONTRACTORS_MODAL_STEPS.GENERAL, text: this.$t('General') },
              { id: CONTRACTORS_MODAL_STEPS.WORKS, text: this.$t('Works') },
              { id: CONTRACTORS_MODAL_STEPS.TENDERS, text: this.$t('Tenders') },
              // { id: CONTRACTORS_MODAL_STEPS.NOTES, text: this.$t('Notes') },
            ]
          : null;
      },
      modalTitle() {
        if (this.contractorName) {
          return this.contractorName;
        }
        return this.context.isTenderContractor
          ? this.$t('Add new contractor')
          : this.$t('Create contractor');
      },
    },
    methods: {
      ...mapActions('contractors', [
        'createContractor',
        'createTenderContractor',
        'saveContractorChanges',
        'closeAddContractorModal',
      ]),
      changeCurrentStep(step) {
        this.currentStep = step;
      },
      async createContractorHandler() {
        if (this.context.isTenderContractor) {
          await this.createTenderContractor();
        } else {
          await this.createContractor();
        }
      },
    },
    created() {
      this.currentStep = this.context.step || CONTRACTORS_MODAL_STEPS.GENERAL;
    },
    watch: {
      form() {
        if (this.form.name) {
          this.contractorName = this.form.name;
        }
      },
    },
  };
</script>
